import $ from 'jquery'

let authWindow = null
let sessionID = null

export function init() {
  $('[data-spotify-auth]').on('click', function () {
    const config = $(this).data('spotify-auth')
    const url = 'https://accounts.spotify.com/authorize?' + $.param(config)
    authWindow = window.open(url, 'spotifyAuth', 'menubar=no,location=no,resizable=yes,status=no,width=600,height=600')
  })

  window.addEventListener(
    'message',
    (event) => {
      if (event.data && typeof event.data !== 'object' && event.data.indexOf('spotify_session_id=') === 0) {
        sessionID = event.data.split('spotify_session_id=')[1]
        console.log('GOT SPOTIFY SESSION', sessionID)
        // authWindow.close();
        initPlayer()
      }
    },
    false
  )
}

export function initPlayer() {
  console.log('Init player')
}
